// @core/api/endpoints/webhook/get_endpoint_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EndpointStatsResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Get endpoint statistics
 * Returns delivery metrics for a specific webhook endpoint including success rates, average latency, and error distribution.
 */
export async function GetEndpointStats(
  endpoint_id: string,
  options?: RequestOptions
): Promise<EndpointStatsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id/stats`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  const requestOptions = options;
  return client.get<EndpointStatsResponse>(requestPath, { ...requestOptions });
}
